import { alpha, Box, Stack, Typography } from "@mui/material";
import AppNavbar from "./AppNavbar";
import ColorModeIconDropdown from "../theme/ColorModeIconDropdown";
import Copyright from "./Copyright";

export default function Layout({ name, children }) {
  return (
    <Box
      style={{
        maxHeight: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <AppNavbar />
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: "center",
            justifyContent: "stretch",
            height: { xs: "calc(100vh - 64px)", md: "100vh" },
            mx: 3,
            pb: 3,
            mt: { xs: 8, md: 0 },
          }}
        >
          <Stack
            direction="row"
            sx={{
              display: { xs: "none", md: "flex" },
              width: "100%",
              alignItems: { xs: "flex-start", md: "center" },
              justifyContent: "space-between",
              maxWidth: { sm: "100%", md: "1700px" },
              pt: 1.5,
            }}
            spacing={2}
          >
            <Typography variant="h1">{name}</Typography>
            <ColorModeIconDropdown />
          </Stack>
          <Box
            sx={{
              width: "100%",
              maxWidth: { sm: "100%", md: "1700px" },
              maxHeight: "100%",
              overflow: "auto",
            }}
          >
            {children}
            <Copyright sx={{ my: 4 }} />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
